module.exports = __webpack_public_path__ + "img/02d.faf61f90.png";